// extracted by mini-css-extract-plugin
export default {"requiredAsterisk":"RequiredField_requiredAsterisk__+vBiP"};